import { apiClient } from "@/api";
import type { ApiResponse, AuthTokens, EdituserReq, User, UserCreate, UserLogin } from "@/types";
import type { AxiosRequestConfig } from "axios";

export async function loginUser(credentials: UserLogin, config?: AxiosRequestConfig): Promise<AuthTokens> {
  const { data } = await apiClient.post<ApiResponse<AuthTokens>>(
    "/auth/login",
    credentials,
    config
  );
  return data.data!;
}

export async function ssoLoginUser(accessToken: string, config?: AxiosRequestConfig): Promise<AuthTokens> {
  const { data } = await apiClient.post<ApiResponse<AuthTokens>>(
    "/auth/sso/login",
    { access_token: accessToken },
    config
  );
  return data.data!;
}

export async function registerUser(payload: UserCreate, config?: AxiosRequestConfig): Promise<{ message: string }> {
  const { data } = await apiClient.post<ApiResponse<{ message: string }>>(
    "/auth/register",
    payload,
    config
  );
  return data.data!;
}

export async function logoutUser(refreshToken: string, config?: AxiosRequestConfig): Promise<void> {
  await apiClient.post("/auth/logout", { refresh_token: refreshToken }, config);
}

export async function refreshTokens(refreshToken: string, config?: AxiosRequestConfig): Promise<AuthTokens> {
  const { data } = await apiClient.post<ApiResponse<AuthTokens>>("/auth/refresh", {
    refresh_token: refreshToken,
  }, config);
  return data.data!;
}

export async function verifyEmail(token: string, config?: AxiosRequestConfig): Promise<void> {
  await apiClient.post("/auth/verify-email", { token }, config);
}

export async function resendVerification(email: string, config?: AxiosRequestConfig): Promise<void> {
  await apiClient.post("/auth/resend-verification", { email }, config);
}

export async function getCurrentUser(config?: AxiosRequestConfig): Promise<User> {
  const { data } = await apiClient.get<ApiResponse<User>>("/users/me", config);
  return data.data!;
}
export async function editUser(req: EdituserReq, config?: AxiosRequestConfig): Promise<User> {
  const { data } = await apiClient.put<ApiResponse<User>>("/users/me", req, config);
  return data.data!;
}

export async function withDraw(config?: AxiosRequestConfig) {
  return apiClient.post('/users/me/withdraw', undefined, config)
}